import { Component, OnInit } from '@angular/core';
import { ModalService } from '../../../core/services/modal.service';
import { DataTaskService } from '../../../core/services/data-task.service';
import { BusinesscoItem, LogisticService } from '../../../services/logistic.service';
import { Item } from '../../../core/components/listbox/listbox.component';
import { GridOptions } from '../../../core/components/grid/grid.types';
import { Grid } from '../../../core/components/grid/grid.model';

@Component({
  selector: 'tt-pick-job-grp-batches',
  templateUrl: './pick-job-grp-batches.component.html',
  styleUrls: ['./pick-job-grp-batches.component.css']
})
export class PickJobGrpBatchesComponent implements OnInit {
    public setting?: Setting;

    public selectListCompanies: BusinesscoItem[] = [];

    public selectListStockPlaces: Item[] = [];

    public selectListPickJobGroups: Item[] = [];

    public grid?: GridOptions;

    public updating = false;

    public creating = false;

    constructor(private modal: ModalService, private datatask: DataTaskService, private logistic: LogisticService) {

    }

    private async loadSetting() {
        this.setting = (await this.datatask.Post(2180))[0];
    }

    private async loadCompanies() {
        this.selectListCompanies = await this.logistic.getCompanies();
    }

    private async loadStockPlaces() {
        if (!this.setting) return;

        return this.selectListStockPlaces = await this.datatask.Post(2181, { businessco_no: this.setting.businessco_no });
    }

    private async loadPickJobGroups() {
        if (!this.setting) return;

        const list = await this.datatask.Post(2234, {
            stockplace_id: this.setting.stockplace_id,
            add_all: '1'
        });

        this.setting.pickjobgrp_keyno = '0';
        this.selectListPickJobGroups = list;
    }

    private loadGrid() {
        if (!this.setting) return;

        if (!this.grid) {
            this.grid = new Grid()
                .setRememberId(this.setting.view_id)
                .setLoadDataFunction({
                    method: this.setting.p2_datatask_keyno,
                    parameters: this.setting
                })
                .setKendoConfig({ height: '100%' })
                .setToolbar({ wrapping: true });
        } else {
            this.grid?.gridfunc?.read();
        }
    }

    public async updateChanges() {
        if (!!this.setting) {
            try {
                this.updating = true;

                const response = (await this.datatask.Post(2182, this.setting))[0];

                if (response?.errorcode !== '0') {
                    this.modal.show({
                        type: 'warning',
                        title: 'error',
                        translateTitle: true,
                        message: response.errormessage
                    });
                }
            } finally {
                this.updating = false;
            }
        }
    }

    public async createChanges() {
        if (!!this.setting) {
            try {
                this.creating = true;

                const response = (await this.datatask.Post(2237, this.setting))[0];

                if (response?.errorcode !== '0') {
                    this.modal.show({
                        type: 'warning',
                        title: 'error',
                        translateTitle: true,
                        message: response.errormessage
                    });
                } else {
                    this.loadGrid();
                }
            } finally {
                this.creating = false;
            }
        }
    }

    public onChanged(_: string, id: keyof Setting) {
        if (!this.setting) return;

        switch (id) {
            case 'businessco_no':
                this.loadStockPlaces();
                break;
            case 'stockplace_id':
                Promise.all([
                    this.loadPickJobGroups()
                ]).then(() => {
                    this.loadGrid();
                    Promise.resolve();
                });
                break;
            case 'show_finished_stocktransfers':
                this.loadGrid();
                break;
            default:
                break;
        }
    }

    private async init() {
        await this.loadSetting();
        this.loadCompanies();
        this.loadStockPlaces();
        
        return Promise.all([
            this.loadPickJobGroups()
        ]).then(() => {
            this.loadGrid();
            Promise.resolve();
        });
    }

    ngOnInit() {
        this.init();
    }
}

interface Setting {
    businessco_no: string;
    stockplace_id: string;
    deliverydate: string;
    pickjobgrp_keyno: string;
    p2_datatask_keyno: number;
    view_id: string;
    show_finished_stocktransfers: string;
}
